module.exports = __webpack_public_path__ + "img/rule_teach.ea54adc3.gif";